import { createAction } from '@reduxjs/toolkit';

export const SAVE_VOICEMAIL_ACTION_TYPE = 'saga/saveVoicemail';
export const saveVoicemailAction = createAction(SAVE_VOICEMAIL_ACTION_TYPE);
